import { withOidcSecure } from '@axa-fr/react-oidc'
import React from 'react'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { appTheme } from '../../../../../../helpers/utils/Utils'

const SpendAlertsItem = ({ data, isShow, type }) => {
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue);
    //alert("isShow"+isShow);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { amount, frequencyType, id } = data
    const handleClick = () => {
        if (type === 'SpendingAlert') {
            const addSpendId = { spendsSelctedId: id }
            dispatch({ type: 'ADD_SPEND_ID', payload: addSpendId });
            navigate('/Toolkit/SpendSenseAlerts/EditSpend/');
        } else {
            const addSavingId = { savingsHABSelectedId: id }
            dispatch({ type: 'ADD_SAVNIGS_HAB_ID', payload: addSavingId });
            navigate('/Toolkit/SavingsHabit/EditHabit');
        }
    };
    return (
        <>
            <div
                className={`flex flex-row justify-between items-center w-full my-8 cursor-pointer ${!isShow ? 'opacity-[0.5]' : 'opacity-1'
                    } ${!isShow ? 'pointer-events-none' : ''}`}
                onClick={handleClick} tabIndex={0} onKeyDown={(e) => { if (e.key === "Enter") handleClick() }}
            >
                <p className="font-hanken-grotesk flex items-center font-[700] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] leading-[16px] text-[var(--climbManage-Spend-p-clr)]">
                {`$${amount}`}
                <span >/</span>
                {`${frequencyType}`}
                </p>
                <img src={appThemeData.nextArrow} alt="arrow" className='mr-[.5rem]' />
            </div>
            <hr className="h-[2px] bg-[var(--climb-border-clr)] border-0 rounded opacity-[65%]" />
        </>
    )
}

export default withOidcSecure(SpendAlertsItem)
